export default {"src":"/_next/static/media/checkbox.6475980f.svg","height":48,"width":48};